import { Component, Input } from "@angular/core";
import {
  DEFAULT_RANGE_PERIOD_FILTER_DATA,
  DEFAULT_SINGLE_PERIOD_FILTER_DATA,
} from "@va/core-library/period-filter";

@Component({
  selector: "app-create-new-comps-wizard",
  templateUrl: "./create-new-comps-wizard.component.html",
  styleUrls: ["./create-new-comps-wizard.component.scss"],
})
export class CreateNewCompsWizardComponent {
  @Input() addRowTableData: Array<any>;
  @Input() userTabId: number;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies: Array<any>;
  @Input() addColTableData: Array<any>;
  // @Input() stdLineItems: Array<any>;
  @Input() currentIndex = 0;
  @Input() filterData: any;
  @Input() openedForAddIn = false;
  @Input() isTickerTypeBg = false;
  @Input() marketItemsData: Array<any>;
  @Input() periodsWithAvailableDataForPopup: any;
  mpt: number = null;
  max: number;
  tickers = [];
  context: string;
  YearTypeData: any = null; //adding for now to store updated year type
  compsName = "";
  createLiDataFetch = false;
  stdLineItems: Array<any> = [];
  createSource = "";

  setContext(context: string) {
    this.context = context;
    if (context === "Comparison") {
      this.max = 50;
      this.YearTypeData = DEFAULT_SINGLE_PERIOD_FILTER_DATA;
    } else {
      this.max = 10;
      this.YearTypeData = DEFAULT_RANGE_PERIOD_FILTER_DATA;
    }
    this.currentIndex = 1;
  }

  moveToNextStep() {
    if (this.currentIndex < 3) {
      this.currentIndex++;
    }
  }

  moveToPreviousStep() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  onUpdateComp(compData) {
    this.addColTableData = compData;
  }

  onTickerUpdate(tickerData) {
    this.addRowTableData = tickerData;
  }

  updateYearType(data) {
    this.YearTypeData = data.updatedPeriodData;
  }

  updateCompsName(compName) {
    this.compsName = compName;
  }

  onMptUpdate(mpt) {
    this.mpt = mpt;
  }
}
